/** @format */

import { FunctionComponent as FC, useContext } from 'react';
import { ThemeContext, styled } from 'styled-components';
import PlusIcon from '../../assets/icons/plus_icon.svg';
import { breakpointFrom } from '../../theme/mixins';
import { ModalLeadership } from '../../types/page';
import { Image } from '../Image';
import { Icon } from '../ui/Icon';
import { P } from '../ui/Typography';

export const TeamCard: FC<Props> = ({ card, openModal }) => {
  const theme = useContext(ThemeContext);
  return (
    <Card role="button" onClick={openModal}>
      <Image image={card.image!} width={357} />
      <Content>
        <Banner>
          <P as="h3" $color={theme?.color.teal.dark}>
            {card.title}
          </P>
          <P $color={theme?.color.teal.dark}>{card.role}</P>
        </Banner>
        <Icon icon={PlusIcon} width={44} height={44} />
      </Content>
    </Card>
  );
};

type Props = {
  card: ModalLeadership;
  openModal: () => void;
};

const Card = styled.div`
  --transition-function: all 0.3s ease-in-out;
  max-width: 22.3125rem;
  ${breakpointFrom.md`
      min-width: 22.313rem;
  `}
  height: 26.375rem;
  display: grid;
  background: ${({ theme }) => theme.color.teal.dark};
  transition: var(--transition-function);
  overflow: hidden;
  cursor: pointer;

  ${breakpointFrom.md`
    min-width: 22.313rem;
  `}

  & > * {
    grid-row: 1;
    grid-column: 1;
  }

  img {
    object-fit: cover;
    display: block;
    width: 100%;
    height: 100%;
    transition: var(--transition-function);
  }

  &:hover,
  &:active,
  &:focus-visible {
    img {
      scale: 1.1;
    }
    i {
      transform: translateX(0) rotate(0);
    }
  }
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-self: end;
  margin-bottom: 1.375rem;
  z-index: 2;

  i {
    margin-left: auto;
    margin-right: 1.5rem;
    align-self: center;
    transition: var(--transition-function);
  }

  ${breakpointFrom.lg`
    i {
      transform: translateX(150%) rotate(180deg);
    }
  `};
`;

const Banner = styled.div`
  background: ${({ theme }) => theme.color.yellow};
  padding: 0.5rem 1rem;

  h3 {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.3125rem;
    letter-spacing: 0.03rem;
  }

  p {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.3125rem;
    letter-spacing: 0.03rem;
  }
`;
